import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// INITIAL STATE
const initialState = {
  input: {
    countryCode: null,
    phoneNumber: null,
  },
  pending: false,
  fulfilled: false,
  rejected: false,
  success: false,
  error: null,
};

const __error__ = {
  errorCode: null,
  captcha: true,
};

// CREATE ACTION
export const validatePhoneNumberAction = createAsyncThunk(
  "phoneNumber/validate",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      let response = await axios.post(
        // local testing
        //`${process.env.REACT_APP_LFCONNECT_FUNCTIONS_DOMAIN}/Auth/captcha/verify?key=${process.env.REACT_APP_LFCONNECT_FUNCTIONS_KEY}`,
        `${process.env.REACT_APP_LFCONNECT_FUNCTIONS_DOMAIN}/integrations/inbody/captcha/verify`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.data.success === true) {
        // validate phone number
        response = await axios.post(
          // local testing
          //`${process.env.REACT_APP_LFCONNECT_FUNCTIONS_DOMAIN}/InBody/users/me/integrations/phone-number?key=${process.env.REACT_APP_LFCONNECT_FUNCTIONS_KEY}`,
          `${process.env.REACT_APP_LFCONNECT_FUNCTIONS_DOMAIN}/users/me/integrations/inbody/phone-number`, // apigee
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${payload.token}`,
            },
          }
        );

        return response.data;
      } else {
        __error__.errorCode = response.data.data["error-codes"][0];
        throw __error__;
      }
    } catch (error) {
      if (error.captcha) return rejectWithValue(error.errorCode);
      else {
        const errorResponse = error.response;
        if (
          errorResponse &&
          errorResponse.data &&
          errorResponse.data.LFconnect &&
          errorResponse.data.error &&
          errorResponse.data.error.innerErrors &&
          errorResponse.data.error.innerErrors.length > 0
        )
          return rejectWithValue(
            errorResponse.data.error.innerErrors[0].target
          );
        else
          return rejectWithValue(
            `${error.message} - Please contact System Administrator.`
          );
      }
    }
  }
);

// CREATE SLICE
const connectInBodySlice = createSlice({
  name: "InBody",
  initialState,
  extraReducers: (builder) => {
    //update account
    builder.addCase(validatePhoneNumberAction.pending, (state, action) => {
      state.pending = true;
      state.fulfilled = false;
      state.rejected = false;
      state.error = null;
    });
    builder.addCase(validatePhoneNumberAction.fulfilled, (state, action) => {
      state.pending = false;
      state.fulfilled = true;
      state.input = {
        countryCode: action.payload.countryCode,
        phoneNumber: action.payload.phoneNumber,
      };
      state.rejected = false;
      state.error = null;
    });
    builder.addCase(validatePhoneNumberAction.rejected, (state, action) => {
      state.pending = false;
      state.fulfilled = false;
      state.rejected = true;
      state.error = action.payload;
      state.input = {
        countryCode: null,
        phoneNumber: null,
      };
    });
  },
});

// CREATE REDUCER
const connectInBodyReducer = connectInBodySlice.reducer;
export default connectInBodyReducer;
